export const VIDEO_PREVIEW = ['image', 'footage', 'shape', 'instance', 'text'];
export const TIMELINE_IMAGE = ['video', 'image', 'footage'];
export const TIMELINE_VIDEO = ['image', 'video', 'footage'];
export const TIMELINE_EMPTY = ['image', 'video', 'footage', 'instance', 'text'];
export const TIMELINE_TRACK = ['instance', 'text', 'shape', 'image', 'video'];
